import styles from "./account.module.scss";
import { Avatar, Stack, Typography } from "@mui/material";
import { Flex, Icon, Image } from "ui";
import classnames from "classnames";
import { useUser } from "contexts";

const Account = () => {
  const { loading, profile } = useUser();

  if (!profile) return null;

  return (
    <Flex
      className={classnames(styles.account, {
        [styles.loading]: loading,
      })}
      spacing={0}
    >
      {profile.name ? (
        profile.photoURL ? (
          <Image
            alt="profile"
            className={styles.profile}
            height={60}
            loading="eager"
            src={profile.photoURL}
            width={60}
          />
        ) : (
          <Avatar className={styles.profile}>{profile.name.charAt(0)}</Avatar>
        )
      ) : (
        <Icon
          className={classnames(styles.profile, styles.circle)}
          name="account_circle"
        />
      )}
      <Stack spacing={0.5}>
        <Typography className={styles.bold} variant="span">
          Personal
        </Typography>
        <Typography variant="h6">{profile.name || "Iniciar sesión"}</Typography>
      </Stack>
      <Icon className={styles.arrow} name="expand_more" />
    </Flex>
  );
};

export default Account;
